import { Injectable, OnInit } from '@angular/core';
import { SystemCodeDesc, SystemCodeEnum } from '../enums/SystemCodeEnum';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StdSystemCodeImportWithAddComponent } from '../shared/components/system-code/std-system-code-import-with-add/std-system-code-import-with-add.component';
import { SystemCodeEditerComponent } from '../shared/components/system-code/system-code-editer/system-code-editer.component';
import { SystemcodeApi, SystemCodeEditOption } from './api-service/system-code/systemcode-api';
import { SystemCodeType } from './api-service/system-code/system-code-type';
import { BaseConfig, FunctionEnable } from './base-config.service';
import { ClinicDataService } from './data-service/clinic-data-service';
import { SystemCode } from './api-service/system-code/system-code';
import { EasyFormService } from './easy-form-service';
import { UserCache } from './user-cache';
/** 注入這個服務的Component 所在的Module要Import VisSystemCodeModule */
@Injectable({
  providedIn: 'root'
})
export class SystemCodeEditService {

  private configs:SystemCodeEditOption = null;
  private openedDialog:MatDialogRef<SystemCodeEditerComponent> = null;
  private promise:(v:any)=>void = null;
  constructor(private dialog: MatDialog,
    private systemcodeApi:SystemcodeApi,
    private clinicData:ClinicDataService,
    private ezForm:EasyFormService){
      
  }
 
  async init(editOption:SystemCodeEditOption = null) {
    if(FunctionEnable.EnableClientAdvCache){
      if(editOption){
        this.configs = editOption;
        return;
      }
    }
    this.configs = await this.systemcodeApi.GetEditOptions(0);
    
  }

  async show(systemCodeType:SystemCodeEnum|string):Promise<boolean>{
    
    if(typeof systemCodeType === 'string'){
      systemCodeType = this.getEnumByType(systemCodeType);
    }
    this.openedDialog = this.dialog.open(SystemCodeEditerComponent,{
        'width':'1200px',
        'height':(BaseConfig.getConfig().ui.pageSize*35 + 150)+ 'px',
        'data':systemCodeType,
        'panelClass':'before-loader',
        'autoFocus':false,
        'disableClose':true,
        
    });
    this.openedDialog.componentInstance.onClosed = this.formClose.bind(this);
    this.openedDialog.componentInstance.setConfig(this.configs,this.configs.systemCodeTypeList.find(x=>x.Id==systemCodeType)?.Type);
    //await this.openedDialog.componentInstance.gridViewComponent.refreshList();
    //this.openedDialog.afterClosed().subscribe();
    var ret = new Promise<boolean>((res,rej)=>{
        this.promise = res;
    });
    return ret;
  }
  /** 給EasyForm UI元件呼叫完成用 */
  async formClose(systemcodeType:string){
    this.openedDialog.close();
    // 更新系統代碼
    await this.clinicData.UpdateSystemCode([systemcodeType])
    this.promise(systemcodeType);
  }
  getEnumByType(systemCodeType:string):SystemCodeEnum{
    return this.configs.systemCodeTypeList.find(x=>x.Type== systemCodeType)?.Id
  }

  async Create(systemCodeType:SystemCodeEnum):Promise<SystemCode>{
    //var typeCode = SystemCodeDesc.find(x=>x.value == systemCodeType).text;
    var codeType = this.configs.systemCodeTypeList.find(x=>x.Id == systemCodeType);
    if(!codeType.CanAdd){
      return null;
    }
    var ret = await this.ezForm.show({
      title:'新增 '+codeType.Name,
      msg:'請輸入代碼與內容',
      fields:{
        Code:{
          name:'Code',
          type:'text',
          value:'',
          label:'代碼'
        },
        Name:{
          name:'Name',
          type:'text',
          value:'',
          label:'內容'
        },
      },
      closeValue:()=>null
    });
    if(ret){
      var clinicId = UserCache.getLoginClinicId();
      var code = await this.systemcodeApi.Create({
        Id:0,
        ClinicId:clinicId,
        Code:ret.Code,
        Name:ret.Name,
        Name1:'',
        Name2:'',
        Name3:'',
        SN:0,
        Sort:0,
        Attribute:'',
        CanEditByClinic:true,
        IsEnabled:true,
        StandardCode:ret.Code,
        Type:systemCodeType,
        TypeCode:codeType.Type,
        checked:true
      });
      await this.clinicData.UpdateSystemCode([codeType.Type])
      return code;
    }
  }
}
/**
 * 
 * 
 */